import React from 'react';
import {CommonList} from '../Common';
import {withStyles} from '@material-ui/core/styles';
import {getFields} from './Common';

export const DocumentTypeList = withStyles({
  autocompleteInput: {fullWidth: true, margin: 300},
})(props => (
  <CommonList {...props} edit fields={getFields()} bulkActionButtons={false} show />
));
